import { makeAutoObservable } from "mobx";
import { ASAPFulfillmentTime, } from "../../ordering";
export class PAsapFulfillmentTime {
    constructor(params) {
        this.type = "ASAP";
        this.restaurant = params.restaurant;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        makeAutoObservable(this);
    }
    get domain() {
        return this.fulfillmentInstructions.fulfillmentTime;
    }
    // TODO: move "ASAP" label translations to the client? (currently received from RPC)
    get label() {
        var _a, _b;
        return (_b = (_a = this.restaurantAsapFulfillmentTime) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "none";
    }
    get restaurantAsapFulfillmentTime() {
        var _a;
        if (this.restaurant.fulfillmentTimes === null) {
            return null;
        }
        return ((_a = this.restaurant.fulfillmentTimes.raw.find((item) => item.type === "ASAP")) !== null && _a !== void 0 ? _a : null);
    }
    get isAvailable() {
        return this.restaurantAsapFulfillmentTime !== null;
    }
    get isActive() {
        return (this.isAvailable && this.domain !== null && this.domain.type === "ASAP");
    }
    setDefaultValue() {
        this.fulfillmentInstructions.fulfillmentTime = new ASAPFulfillmentTime(this.label);
    }
    setDate() {
        throw new Error("ASAP fulfillment time cannot set date");
    }
    setHour() {
        throw new Error("ASAP fulfillment time cannot set hour");
    }
}
